import type { FetchFunction } from '#layers/base/public';

interface RoleIdPayload {
	id: string;
}

interface UpdateMemberRolesOptions {
	fetch: FetchFunction;
	memberId: string;
	roleIds: string[];
}

export async function connectMemberRoles({ fetch, memberId, roleIds }: UpdateMemberRolesOptions): Promise<void> {
	if (roleIds.length === 0) return;

	const payload: RoleIdPayload[] = roleIds.map((id) => ({ id }));

	await fetch(`members/${memberId}/roles`, {
		method: 'POST',
		body: payload,
	});
}

export async function disconnectMemberRoles({ fetch, memberId, roleIds }: UpdateMemberRolesOptions): Promise<void> {
	if (roleIds.length === 0) return;

	const payload: RoleIdPayload[] = roleIds.map((id) => ({ id }));

	await fetch(`members/${memberId}/roles`, {
		method: 'DELETE',
		body: payload,
	});
}
